import { render, staticRenderFns } from "./buy-sell.vue?vue&type=template&id=1f136114&"
import script from "./buy-sell.vue?vue&type=script&lang=js&"
export * from "./buy-sell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports